import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { requireRolesOrAdminGuard } from './core/interceptor/require-roles-or-admin.guard';
import { ErrorComponent } from './core/component/error/error.component';

// Todo entender o que está rolando com o guard e fver se faz sentido

const routes: Routes = [
    {
        path: '',
        redirectTo: 'health/analysis',
        pathMatch: 'full'
    }, {
        path: 'iam',
        loadChildren: () => import('./module/iam/iam.module').then(module => module.IamModule),
    }, {
        path: 'health/analysis',
        loadChildren: () => import('./module/health-analysis/health-analysis.module').then(module => module.HealthAnalysisModule),
    }, {
        path: 'partner',
        loadChildren: () => import('./module/partner/partner.module').then(module => module.PartnerModule),
    }, {
        path: 'email',
        canActivate: [requireRolesOrAdminGuard],
        data: { roles: ['ciera-tech'] },
        loadChildren: () => import('./module/email/email.module').then(module => module.EmailModule),
    }, {
        path: 'self-onboarding',
        canActivate: [requireRolesOrAdminGuard],
        data: { roles: ['ciera-tech'] },
        loadChildren: () => import('./module/self-onboarding/self-onboarding.module').then(module => module.SelfOnboardingModule),
    }, {
        path: 'error',
        component: ErrorComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
